export default __webpack_public_path__ + "static/truck_b.df61694989e1b9066c94464d361114da.png";